import React from "react";
import { Source } from "../../http/protocol";

interface SourceBadgeProps {
  source?: Source;
}

/**
 * Colour-coded badge identifying which backend (v1 bonus service or v2 cashback service)
 * a unified row was sourced from. Shared by the cashback log, per-currency payout, and
 * single-currency payout list views.
 */
export function SourceBadge({ source }: SourceBadgeProps) {
  if (!source) {
    return <span className="badge badge-secondary" />;
  }
  const className = source === Source.V2 ? "badge badge-info" : "badge badge-secondary";
  return <span className={className}>{source}</span>;
}
